export * from './ps-modal-lupa.component';
